export default __webpack_public_path__ + "static/media/Juneau-Regular.9f17efe0.otf";